import React, { createContext, useCallback, useContext, useState } from 'react';

const IntroContext = createContext({ ready: true, finish: () => {} });
const SESSION_KEY = 'dvs-intro-seen';

// Whether the first-visit preloader should play: once per browser session, never for reduced
// motion, and not when the session starts on the landing page (its WebGL opening has its own gate)
export const shouldPlayIntro = () => {
  try {
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return false;
    if (window.location.pathname === '/' || window.location.pathname === '/lab') return false;
    return sessionStorage.getItem(SESSION_KEY) !== '1';
  } catch {
    return false;
  }
};

/*
 * `ready` turns true when the preloader starts lifting (or immediately when it doesn't play),
 * so hero reveals start as the page is uncovered instead of playing unseen underneath.
 */
export const IntroProvider = ({ children }) => {
  const [ready, setReady] = useState(() => !shouldPlayIntro());
  const finish = useCallback(() => {
    try {
      sessionStorage.setItem(SESSION_KEY, '1');
    } catch {
      // Storage blocked: the intro may replay on the next page load, which is harmless
    }
    setReady(true);
  }, []);
  return <IntroContext.Provider value={{ ready, finish }}>{children}</IntroContext.Provider>;
};

export const useIntro = () => useContext(IntroContext);
